import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cultural',
  templateUrl: './cultural.component.html',
  styleUrls: ['./cultural.component.scss']
})
export class CulturalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
